import {nextTick} from 'vue';
import VueMultiselect from 'vue-multiselect';
import VueScrollTo from 'vue-scrollto';

const VueMultiselectExtended = {
    extends: VueMultiselect,
    props: {
        noScroll: {default: false},
    },
    watch: {
        isOpen(val) {
            if (val && !this.noScroll) {
                nextTick(() => {
                    const getScrollParent = (node) => {
                        const isElement = node instanceof HTMLElement;
                        const overflowY = isElement && window.getComputedStyle(node).overflowY;
                        const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

                        if (!node) {
                            return null;
                        } else if (isScrollable && node.scrollHeight >= node.clientHeight) {
                            return node;
                        }

                        return getScrollParent(node.parentNode) || document.body;
                    };

                    const paddingTop = 10;
                    const multiselectScrollingOffset = -this.$el.getBoundingClientRect().height - paddingTop;
                    const options = {
                        container: getScrollParent(this.$refs.list.parentNode),
                        offset: multiselectScrollingOffset,
                        force: false,
                        cancelable: false,
                        onDone: () => { },
                        x: false,
                    };

                    const smoothScrollDuration = 1000;
                    VueScrollTo.scrollTo(this.$refs.list, smoothScrollDuration, options);
                });
            }
        },
    },
};

export default VueMultiselectExtended;
